module.exports = __webpack_public_path__ + "static/media/3DPPA20.19e4f4f3.jpg";